<template>
  <div style="padding: 20px">
    <div
      style="
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 20px;
      "
    >
      <!-- Заголовок -->
      <div style="width: 100%; text-align: center; margin-bottom: 20px">
        <h1 style="margin: 0">⭐ Доска почёта ⭐</h1>
        <p style="color: #666">Ученики, добившиеся выдающихся успехов</p>
      </div>

      <!-- Фильтры -->
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 15px;
          flex-wrap: wrap;
        "
      >
        <div style="width: 200px">
          <b>Класс</b>
          <select class="form-select" v-model="classFilter" @change="loadAll()">
            <option value="">Все классы</option>
            <option v-for="c in classList" :key="c.classID" :value="c.classID">
              {{ c.className }}
            </option>
          </select>
        </div>

        <div style="width: 200px">
          <b>Период</b>
          <select class="form-select" v-model="period" @change="loadAll()">
            <option value="all">За всё время</option>
            <option value="year">За текущий год</option>
            <option value="quarter">За текущий квартал</option>
            <option value="month">За текущий месяц</option>
          </select>
        </div>

        <div style="width: 200px">
          <b>Показывать</b>
          <select class="form-select" v-model="mode" @change="loadAll()">
            <option value="honor">Только Доска почёта</option>
            <option value="top">Топ-N по баллам</option>
          </select>
        </div>
      </div>
    </div>

    <!-- ==================== ПЕРВЫЕ 3 МЕСТА (ПЬЕДЕСТАЛ) ==================== -->
    <div
      v-if="topThree.length"
      style="
        display: flex;
        justify-content: center;
        align-items: flex-end;
        gap: 20px;
        margin: 40px 0;
        flex-wrap: wrap;
      "
    >
      <!-- 2-е место -->
      <div v-if="topThree[1]" class="podium podium-2">
        <div class="podium-photo">
          <img v-if="topThree[1].photo" :src="topThree[1].photo" />
          <div v-else class="podium-photo-placeholder">
            {{ initials(topThree[1]) }}
          </div>
        </div>
        <div class="podium-medal">🥈</div>
        <div class="podium-name">
          {{ topThree[1].FirstName }} {{ topThree[1].LastName }}
        </div>
        <div class="podium-class">
          {{ classNameById(topThree[1].classID) }}
        </div>
        <div class="podium-points">{{ topThree[1].points }} б.</div>
      </div>

      <!-- 1-е место -->
      <div v-if="topThree[0]" class="podium podium-1">
        <div class="podium-photo">
          <img v-if="topThree[0].photo" :src="topThree[0].photo" />
          <div v-else class="podium-photo-placeholder">
            {{ initials(topThree[0]) }}
          </div>
        </div>
        <div class="podium-medal">🥇</div>
        <div class="podium-name">
          {{ topThree[0].FirstName }} {{ topThree[0].LastName }}
        </div>
        <div class="podium-class">
          {{ classNameById(topThree[0].classID) }}
        </div>
        <div class="podium-points">{{ topThree[0].points }} б.</div>
      </div>

      <!-- 3-е место -->
      <div v-if="topThree[2]" class="podium podium-3">
        <div class="podium-photo">
          <img v-if="topThree[2].photo" :src="topThree[2].photo" />
          <div v-else class="podium-photo-placeholder">
            {{ initials(topThree[2]) }}
          </div>
        </div>
        <div class="podium-medal">🥉</div>
        <div class="podium-name">
          {{ topThree[2].FirstName }} {{ topThree[2].LastName }}
        </div>
        <div class="podium-class">
          {{ classNameById(topThree[2].classID) }}
        </div>
        <div class="podium-points">{{ topThree[2].points }} б.</div>
      </div>
    </div>

    <!-- ==================== ПОЛНЫЙ СПИСОК ==================== -->
    <div
      style="
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 4px 4px 8px rgba(0, 72, 172, 0.15);
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h3 style="margin: 0">
          {{ mode === "honor" ? "Все на Доске почёта" : "Топ учеников" }}
          <span style="color: #666; font-size: 0.8em">
            ({{ students.length }})
          </span>
        </h3>
        <button class="btn btn-dark" @click="exportData()">ЭКСПОРТ</button>
      </div>

      <div
        v-if="!students.length"
        style="text-align: center; padding: 40px; color: #999"
      >
        Пока никто не попал на Доску почёта
      </div>

      <table v-else class="honor-table">
        <tr>
          <th>#</th>
          <th>Ученик</th>
          <th>Класс</th>
          <th>Баллы</th>
          <th>Дата попадания</th>
          <th v-if="selectedClass && selectedClass.classID === 'admin'">
            Действия
          </th>
        </tr>
        <tr
          v-for="(s, i) in students"
          :key="s._id"
          :class="{
            'row-top1': i === 0,
            'row-top2': i === 1,
            'row-top3': i === 2,
          }"
        >
          <td>{{ i + 1 }}</td>
          <td>
            <div style="display: flex; align-items: center; gap: 10px">
              <div class="mini-photo">
                <img v-if="s.photo" :src="s.photo" />
                <div v-else class="mini-photo-placeholder">
                  {{ initials(s) }}
                </div>
              </div>
              <b>{{ s.FirstName }} {{ s.LastName }}</b>
            </div>
          </td>
          <td>{{ classNameById(s.classID) }}</td>
          <td>
            <b style="color: #2e7d32">{{ s.points }}</b>
          </td>
          <td>
            <span v-if="s.HonorBoard && s.HonorBoard.date">
              {{ new Date(s.HonorBoard.date).toLocaleDateString() }}
            </span>
            <span v-else style="color: #999">—</span>
          </td>
          <td v-if="selectedClass && selectedClass.classID === 'admin'">
            <button
              class="btn btn-danger btn-sm"
              @click="removeFromHonorBoard(s)"
            >
              Снять с доски
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../services/TutorialDataService";
import * as XLSX from "xlsx";

export default {
  props: {
    selectedClass: Object,
  },
  data() {
    return {
      classList: [],
      students: [], // полный список для таблицы
      topThree: [], // первые 3 для пьедестала
      classFilter: "",
      period: "all",
      mode: "honor", // honor | top
    };
  },
  methods: {
    // -------- ЗАГРУЗКА --------
    async loadAll() {
      if (this.mode === "honor") {
        await this.loadHonorBoard();
      } else {
        await this.loadTop();
      }
    },

    async loadHonorBoard() {
      try {
        const r = await TutorialDataService.getStudentsWithHonorBoard();
        let list = r.data.data || r.data || [];

        // фильтр по классу
        if (this.classFilter) {
          list = list.filter((s) => s.classID === this.classFilter);
        }

        // Сортируем по TotalPoints, чтобы на пьедестале были лучшие
        list = list
          .map((s) => ({
            _id: s._id,
            FirstName: s.FirstName,
            LastName: s.LastName,
            Surname: s.Surname,
            classID: s.classID,
            photo: s.photo,
            HonorBoard: s.HonorBoard,
            points: this.getPointsByPeriod(s, this.period),
          }))
          .sort((a, b) => b.points - a.points);

        this.students = list;
        this.topThree = list.slice(0, 3);
      } catch (e) {
        console.error(e);
      }
    },

    async loadTop() {
      try {
        const r = await TutorialDataService.getRating(
          this.mapPeriod(this.period),
          this.classFilter,
        );
        const list = (r.data || []).slice(0, 20); // топ-20
        this.students = list;
        this.topThree = list.slice(0, 3);
      } catch (e) {
        console.error(e);
      }
    },

    // -------- УТИЛИТЫ --------
    mapPeriod(p) {
      // сервер понимает "all", "2025", "2025-Q1", "2025-04"
      const now = new Date();
      const y = now.getFullYear();
      if (p === "year") return String(y);
      if (p === "quarter") return `${y}-Q${Math.floor(now.getMonth() / 3) + 1}`;
      if (p === "month")
        return `${y}-${String(now.getMonth() + 1).padStart(2, "0")}`;
      return "all";
    },

    getPointsByPeriod(s, p) {
      if (p === "all") return s.TotalPoints || 0;
      const key = this.mapPeriod(p);
      return (s.TotalPointsPeriod && s.TotalPointsPeriod[key]) || 0;
    },

    initials(s) {
      const f = (s.FirstName || "").charAt(0);
      const l = (s.LastName || "").charAt(0);
      return (f + l).toUpperCase();
    },

    classNameById(id) {
      const c = this.classList.find((x) => x.classID === id);
      return c ? c.className : id || "—";
    },

    async getAllClass() {
      try {
        const r = await TutorialDataService.getAllCLass();
        this.classList = r.data.map((c) => ({
          classID: c._id,
          className: c.className,
        }));
      } catch (e) {
        console.error(e);
      }
    },

    // -------- СНЯТИЕ С ДОСКИ (только админ) --------
    async removeFromHonorBoard(s) {
      if (!confirm(`Снять ${s.FirstName} ${s.LastName} с Доски почёта?`))
        return;
      try {
        await TutorialDataService.deleteStudentFromHonorBoard(s._id);
        await this.loadAll();
      } catch (e) {
        console.error(e);
        alert("Ошибка");
      }
    },

    // -------- ЭКСПОРТ --------
    exportData() {
      const data = [
        ["#", "Фамилия", "Имя", "Класс", "Баллы", "Дата попадания"],
      ];
      this.students.forEach((s, i) => {
        data.push([
          i + 1,
          s.LastName,
          s.FirstName,
          this.classNameById(s.classID),
          s.points,
          s.HonorBoard && s.HonorBoard.date
            ? new Date(s.HonorBoard.date).toLocaleDateString()
            : "",
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(data);
      wb.SheetNames.push("HonorBoard");
      wb.Sheets["HonorBoard"] = ws;
      var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

      function s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }

      const blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Доска почёта.xlsx";
      link.click();
    },
  },

  async mounted() {
    await this.getAllClass();
    await this.loadAll();
  },
};
</script>

<style scoped>
/* ==================== ПЬЕДЕСТАЛ ==================== */
.podium {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 15px;
  border-radius: 12px 12px 0 0;
  min-width: 180px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}
.podium:hover {
  transform: translateY(-5px);
}
.podium-1 {
  background: linear-gradient(180deg, #ffe082 0%, #ffb300 100%);
  padding-bottom: 40px;
  min-width: 220px;
}
.podium-2 {
  background: linear-gradient(180deg, #e0e0e0 0%, #9e9e9e 100%);
  padding-bottom: 25px;
}
.podium-3 {
  background: linear-gradient(180deg, #ffcc80 0%, #e65100 100%);
  padding-bottom: 15px;
  color: #fff;
}
.podium-photo {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.podium-1 .podium-photo {
  width: 110px;
  height: 110px;
}
.podium-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.podium-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1976d2;
  color: #fff;
  font-size: 32px;
  font-weight: bold;
}
.podium-medal {
  font-size: 40px;
  margin: 8px 0;
}
.podium-name {
  font-weight: bold;
  text-align: center;
  font-size: 1.05em;
}
.podium-class {
  font-size: 0.9em;
  color: #555;
}
.podium-points {
  margin-top: 6px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  font-weight: bold;
  color: #2e7d32;
}

/* ==================== ТАБЛИЦА ==================== */
.honor-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}
.honor-table th {
  text-align: left;
  padding: 10px;
  background: #f5f5f5;
  border-bottom: 2px solid #ddd;
  font-weight: 600;
}
.honor-table td {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.honor-table tr:hover {
  background: #f9f9f9;
}
.row-top1 {
  background: #fff8e1;
}
.row-top2 {
  background: #fafafa;
}
.row-top3 {
  background: #fff3e0;
}

.mini-photo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.mini-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mini-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1976d2;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
}
</style>
